import {
  CampaignSimulationStepsIds,
  CampaignSimulationStepsUnion,
  Status,
  StepDetails,
} from "types/stepper";

export const eventStep: StepDetails<CampaignSimulationStepsUnion> = {
  id: CampaignSimulationStepsIds.EVENT,
  label: "eventDetails",
  status: Status.NOT_VISITED,
};

export const transactionStep: StepDetails<CampaignSimulationStepsUnion> = {
  id: CampaignSimulationStepsIds.TRANSACTION,
  label: "transaction",
  status: Status.NOT_VISITED,
};
